module.exports = __webpack_public_path__ + "assets/crown.76a156bb.svg";